import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router';
import { RemindersSettingsView } from '@/components/organisms/settings-reminders/RemindersSettingsView';

export const Route = createFileRoute('/_dashboard/dashboard/settings/reminders')({
  // `view` is optional: config (the per-type policy editor) is the default, so a
  // bare /dashboard/settings/reminders carries no search param. Only the live
  // Queue view adds ?view=queue — keeping the param optional so child routes and
  // links to this page don't have to thread it through.
  validateSearch: (search: Record<string, unknown>): { view?: 'queue' } =>
    search.view === 'queue' ? { view: 'queue' } : {},
  component: RemindersSettingsLayout,
});

function RemindersSettingsLayout() {
  const matches = useMatches();
  const { view } = Route.useSearch();
  const isOnChildRoute = matches.some((match) =>
    match.routeId.startsWith('/_dashboard/dashboard/settings/reminders/'),
  );

  if (isOnChildRoute) {
    return <Outlet />;
  }

  return (
    <RemindersSettingsView
      activeType="JOB_CONFIRMATION"
      view={view === 'queue' ? 'queue' : 'config'}
    />
  );
}
